import { Link } from "expo-router"

import { Text } from "wealthmode-frontend/gluestack/ui"

/**
 * A row's ID in a list, linked to that resource's own page. Only rows that have
 * such a page get one - an ID with nowhere to go stays plain text.
 */
export default function IDLink({ href, id }: { href: string; id: string }) {
  return (
    <Link href={href}>
      <Text className="text-markdown-link hover:opacity-80 underline whitespace-nowrap">{id}</Text>
    </Link>
  )
}
